import React, { createContext, useState, useContext } from 'react';

// Create context
const LocationModalContext = createContext();

// Custom hook to use the location modal context
export const useLocationModal = () => useContext(LocationModalContext);

// Provider component
export function LocationModalProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Function to open the location modal
  const openLocationModal = () => {
    setIsModalOpen(true);
  };
  
  // Function to close the location modal
  const closeLocationModal = () => {
    setIsModalOpen(false);
  };
  
  // Context value
  const contextValue = {
    isModalOpen,
    openLocationModal,
    closeLocationModal
  };
  
  return (
    <LocationModalContext.Provider value={contextValue}>
      {children}
    </LocationModalContext.Provider>
  );
}

